const SHOWN_KEY = 'campaignPopupShown';
const PENDING_KEY = 'campaignPopupPending';

export function isCampaignPopupEnabled() {
  const flag = String(process.env.VUE_APP_CAMPAIGN_POPUP || '').trim().toLowerCase();
  const owner = String(process.env.VUE_APP_OWNER_ID || '').replace(/['"]/g, '').trim();
  if (flag !== 'on' && !flag.startsWith('on')) return false;
  if (owner && !['36', '39'].includes(owner)) return false;
  return true;
}

export function markCampaignPopupPending() {
  try {
    sessionStorage.setItem(PENDING_KEY, '1');
    sessionStorage.removeItem(SHOWN_KEY);
  } catch (e) {
    // sessionStorage pode falhar em modo privado
  }
}

export function consumeCampaignPopupIfNeeded() {
  if (!isCampaignPopupEnabled()) return false;
  try {
    if (sessionStorage.getItem(SHOWN_KEY) === '1') return false;
    sessionStorage.setItem(SHOWN_KEY, '1');
    sessionStorage.removeItem(PENDING_KEY);
    return true;
  } catch (e) {
    return true;
  }
}
